// helper methods for saveing and removeing access and refresh tokens in local storage

export const saveAccessToken = (token: string): any => {
  return localStorage.setItem("access-token", token);
};

export const getAccessToken = (): any => {
  return localStorage.getItem("access-token");
};

export const saveRefreshToken = (refreshToken: string): any => {
  return localStorage.setItem("refresh-token", refreshToken);
};

export const getRefreshToken = (): any => {
  return localStorage.getItem("refresh-token");
};

export const setLastVisitedStudio = (studioId: string): any => {
  return localStorage.setItem("last-visited-studio", studioId);
};

export const getLastVisitedStudio = (): any => {
  return localStorage.getItem("last-visited-studio");
};

export const setResource = (studioId: string): any => {
  return localStorage.setItem("resource", studioId);
};

export const getResource = (): any => {
  return localStorage.getItem("resource");
};

export const deleteAccessAndRefreshToken = (): any => {
  localStorage.removeItem("access-token");
  localStorage.removeItem("refresh-token");
};
